import { Routes } from '@angular/router';
import { EXCHANGE_RATE_CONFIG } from './base/exchange-rate-config';

/**
 * ExchangeRate 라우팅 (표준 패턴)
 *
 * Modern Angular 21+ 패턴:
 * - ✅ Lazy loading (loadComponent)
 * - ✅ /list 서브경로 표준화
 * - ✅ Config-Driven routePath
 * - ✅ Resolver 제거 (rxResource 사용)
 */
export const exchangeRateRoutes: Routes = [
  {
    path: EXCHANGE_RATE_CONFIG.routePath,
    data: {
      title: '환율 관리',
    },
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
      {
        path: 'list',
        loadComponent: () =>
          import(
            './components/smart/exchange-rate-list-page/exchange-rate-list-page.component'
          ).then((m) => m.ExchangeRateListPageComponent),
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import(
                './components/smart/exchange-rate-detail-page/exchange-rate-detail-page.component'
              ).then((m) => m.ExchangeRateDetailPageComponent),
            data: {
              title: '환율 상세',
            },
          },
        ],
      },
    ],
  },
];
